import { render } from "./ModalDetailAgenda.vue?vue&type=template&id=4fa2fdf9"
import script from "./ModalDetailAgenda.vue?vue&type=script&lang=js"
export * from "./ModalDetailAgenda.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__